import { observable, action } from 'mobx';
import { CupSize } from './utils';

export const FMSModalState: FMSModalStateShape = observable({
  bust: null,
  cup: null,
  sizeResult: null,
});

export const setBustFromUsersInput = action((value: string) => {
  FMSModalState.bust = value;
});

export const setCupFromUsersInput = action((value: CupSize) => {
  FMSModalState.cup = value;
});

export const setSizeResult = action((value?: string) => {
  FMSModalState.sizeResult = value || null;
});

export interface FMSModalStateShape {
  bust: string | null;
  cup: CupSize | null;
  sizeResult: string | null;
}
